import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import NarrowInfoContainer from "../components/NarrowInfoContainer";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { localizations } from '../localization/localization';

interface PasswordChangedProps {
    title: string,
    information: string,
    continueButtonLabel: string,
    onContinue: () => void;
}

const PasswordChangedSuccess: React.SFC<PasswordChangedProps> = (props) => {
    return <NarrowInfoContainer>
        <Grid item xs>
            <Grid container alignItems={'center'} justify={'center'} direction={"column"} spacing={3}>
                <Grid item>
                    <Typography variant="h6">{localizations.validation.passwordChanged}</Typography>
                </Grid>
                <Grid item>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <Button variant="outlined">{localizations.map.toMapView}</Button>
                    </Link>
                </Grid>
            </Grid>
        </Grid>
    </NarrowInfoContainer>
}

export default PasswordChangedSuccess;


// WEBPACK FOOTER //
// ./src/login/PasswordChangedSuccess.tsx